/**
 * A FogVolume node in the scene graph, which the volumetric fog finds and draws. It carries its
 * node's world transform, and the shape and fill the light pass reads.
 */
import * as THREE from 'three';
import { FOG_VOLUME_DEFAULT_SHAPE, FOG_VOLUME_DEFAULT_SIZE, } from '../../godot/rendering/environment/fogVolume.js';
export const DEFAULT_FOG_VOLUME_FILL = { kind: 'default' };
export class FogVolumeObject extends THREE.Object3D {
    isFogVolume = true;
    size = new THREE.Vector3(FOG_VOLUME_DEFAULT_SIZE.x, FOG_VOLUME_DEFAULT_SIZE.y, FOG_VOLUME_DEFAULT_SIZE.z);
    shape = FOG_VOLUME_DEFAULT_SHAPE;
    fill = DEFAULT_FOG_VOLUME_FILL;
}
export function isFogVolume(object) {
    return object.isFogVolume === true;
}
//# sourceMappingURL=fogVolumeObject.js.map